import { toast } from "react-toastify";
import { call, put, takeEvery } from "redux-saga/effects";
import { onLoaderTrigger } from "redux/actions/CommonAction";
import { postCashfreepayment } from "redux/actions/UserCashFreeAction";
import { getPaymentHash, getPaymentMethod } from "redux/actions/UserPayment";
import store from "redux/store";
import {
  GET_CANCEL_REASON_FAILED,
  GET_CANCEL_REASON_REQUESTED,
  GET_CANCEL_REASON_SUCCESS,
  GET_CANCEL_TRIP_FAILED,
  GET_CANCEL_TRIP_REQUESTED,
  GET_CANCEL_TRIP_SUCCESS,
  GET_RATE_CALCULATION_FAILED,
  GET_RATE_CALCULATION_REQUESTED,
  GET_RATE_CALCULATION_SUCCESS,
  GET_REFUND_PRICE_FAILED,
  GET_REFUND_PRICE_REQUESTED,
  GET_REFUND_PRICE_SUCCESS,
  GET_TRIP_CHECKOUT_FAILED,
  GET_TRIP_CHECKOUT_REQUESTED,
  GET_TRIP_CHECKOUT_SUCCESS,
  GET_TRIP_SLAB_FAILED,
  GET_TRIP_SLAB_REQUESTED,
  GET_TRIP_SLAB_SUCCESS,
  GET_RENATAL_SLAB_FAILED,
  GET_RENATAL_SLAB_REQUESTED,
  GET_RENATAL_SLAB_SUCCESS,
} from "resources/actionTypes";
import {
  cancelReasonApi,
  cancelTripApi,
  rateCalculationApi,
  refundPriceApi,
  tripCheckoutApi,
  tripSlabApi,
  rentalSlabApi,
} from "services/CustomerTripService";
import { tripEnumObject } from "utils/enumObject";

function* fetchRateCalculation(action) {
  const payload = action.payload || {};
  const userRateCalculation = yield call(
    rateCalculationApi,
    payload?.userRateCalculation
  );
  if (userRateCalculation?.success) {
    yield put({
      type: GET_RATE_CALCULATION_SUCCESS,
      userRateCalculation: userRateCalculation,
    });
  } else {
    yield put({
      type: GET_RATE_CALCULATION_FAILED,
      message: userRateCalculation?.message,
    });
      toast.error(userRateCalculation?.message || "Added Rate Calculation failed");
      localStorage.removeItem('trip');
  }
}
export function* rateCalculationSaga() {
  yield takeEvery(GET_RATE_CALCULATION_REQUESTED, fetchRateCalculation);
}

function* fetchTripCheckout(action) {
  const payload = action.payload || {};
  store.dispatch(onLoaderTrigger(true));
  const userTripCheckout = yield call(
    tripCheckoutApi,
    payload?.userTripCheckout
  );
  if (userTripCheckout?.success) {
    yield put({
      type: GET_TRIP_CHECKOUT_SUCCESS,
      userTripCheckout: userTripCheckout,
    });
    toast.success(
      userTripCheckout?.message
        ? userTripCheckout?.message
        : "trip data fetch successfully"
    );
    store.dispatch(onLoaderTrigger(false));
    localStorage.setItem('trip',true);
    if(JSON.stringify(userTripCheckout?.data?.tripDetails?.type) === tripEnumObject?.outStationRound){
      payload?.navigate('/payment',{state:{tripData: userTripCheckout?.data?.tripDetails}})
    }else{
      store.dispatch(postCashfreepayment({
        transactionId: userTripCheckout?.data?.transactionId,
      }))
    }
  } else {
    yield put({
      type: GET_TRIP_CHECKOUT_FAILED,
      message: userTripCheckout?.message,
    });
      toast.error(userTripCheckout?.message || "trip data fetch failed");
      localStorage.removeItem('trip');
      store.dispatch(onLoaderTrigger(false));
  }
}
export function* tripCheckoutSaga() {
  yield takeEvery(GET_TRIP_CHECKOUT_REQUESTED, fetchTripCheckout);
}

function* fetchTripSlab(action) {
  const payload = action.payload || {};
  store.dispatch(onLoaderTrigger(true));
  const userTripSlab = yield call(tripSlabApi, payload?.userTripSlab);
  if (userTripSlab?.success) {
    yield put({ type: GET_TRIP_SLAB_SUCCESS, userTripSlab: userTripSlab });
    store.dispatch(onLoaderTrigger(false));
  } else {
    yield put({ type: GET_TRIP_SLAB_FAILED, message: userTripSlab?.message });
      toast.error(userTripSlab?.message || "Added Airport failed");
      store.dispatch(onLoaderTrigger(false));
  }
}
export function* tripSlabSaga() {
  yield takeEvery(GET_TRIP_SLAB_REQUESTED, fetchTripSlab);
}
function* fetchCancelTrip(action) {
  const payload = action.payload || {};
  store.dispatch(onLoaderTrigger(true));
  const userCancelTrip = yield call(cancelTripApi, payload?.userCancelTrip);
  if (userCancelTrip?.success) {
    yield put({
      type: GET_CANCEL_TRIP_SUCCESS,
      userCancelTrip: userCancelTrip,
    });
    payload.navigate('/confirmRide',{state:{cancelTrip:true}})
    store.dispatch(onLoaderTrigger(false));
  } else {
    yield put({
      type: GET_CANCEL_TRIP_FAILED,
      message: userCancelTrip?.message,
    });
      toast.error(userCancelTrip?.message || "fetching CancelTrip failed");
      store.dispatch(onLoaderTrigger(false));
  }
}
export function* cancelTripSaga() {
  yield takeEvery(GET_CANCEL_TRIP_REQUESTED, fetchCancelTrip);
}

function* fetchCancelReason(action) {
  const payload = action.payload || {};
  const userCancelReason = yield call(
    cancelReasonApi,
    payload?.userCancelReason
  );
  if (userCancelReason?.success) {
    yield put({
      type: GET_CANCEL_REASON_SUCCESS,
      userCancelReason: userCancelReason,
    });
  } else {
    yield put({
      type: GET_CANCEL_REASON_FAILED,
      message: userCancelReason?.message,
    });
      toast.error(userCancelReason?.message || "Fetching Cancel Reason failed");
  }
}
export function* cancelReasonSaga() {
  yield takeEvery(GET_CANCEL_REASON_REQUESTED, fetchCancelReason);
}

function* fetchRefundPrice(action) {
  const payload = action.payload || {};
  const userRefundPrice = yield call(refundPriceApi, payload?.userRefundPrice);
  if (userRefundPrice?.success) {
    yield put({
      type: GET_REFUND_PRICE_SUCCESS,
      userRefundPrice: userRefundPrice,
    });
  } else {
    yield put({
      type: GET_REFUND_PRICE_FAILED,
      message: userRefundPrice?.message,
    });
      toast.error(userRefundPrice?.message || "Fetching RefundPrice failed");
  }
}
export function* refundPriceSaga() {
  yield takeEvery(GET_REFUND_PRICE_REQUESTED, fetchRefundPrice);
}

function* fetchRentalSlab(action) {
  const payload = action.payload || {};
  const userRentalSlab = yield call(rentalSlabApi, payload?.userRentalSlab);
  if (userRentalSlab?.success) {
    yield put({
      type: GET_RENATAL_SLAB_SUCCESS,
      userRentalSlab: userRentalSlab,
    });
  } else{
    yield put({
      type: GET_RENATAL_SLAB_FAILED,
      message: userRentalSlab?.message,
    });
      toast.error(userRentalSlab?.message || "fetching Rate Calculation failed");
  }
}
export function* rentalSlabSaga() {
  yield takeEvery(GET_RENATAL_SLAB_REQUESTED, fetchRentalSlab);
}
